'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('..');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = _.CaligramReact.config();

var Icon = function Icon(_ref) {
  var name = _ref.name;

  if (!config.icons[name]) {
    throw new Error('Icon \'' + name + '\' is not specified in caligram-react config');
  }

  var IconComponent = config.icons[name];
  return _react2.default.createElement(IconComponent, { className: name });
};

Icon.propTypes = {
  /**
   * File name of the icon.
   */
  name: _propTypes2.default.string.isRequired
};

exports.default = Icon;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Icon.js
// module id = 272
// module chunks = 0